import { useEffect, useState, type ReactNode, type FormEvent } from "react";

const GATE_KEY = "uc_site_gate_unlocked";
const GATE_PASSWORD = "100/99";

export const SiteGate = ({ children }: { children: ReactNode }) => {
  const [unlocked, setUnlocked] = useState<boolean | null>(null);
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    try {
      setUnlocked(localStorage.getItem(GATE_KEY) === "1");
    } catch {
      setUnlocked(false);
    }
  }, []);

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (value.trim() === GATE_PASSWORD) {
      try {
        localStorage.setItem(GATE_KEY, "1");
      } catch {
        /* ignore */
      }
      setUnlocked(true);
    } else {
      setError(true);
      setValue("");
    }
  };

  if (unlocked === null) {
    return <div className="fixed inset-0 bg-black" aria-hidden="true" />;
  }

  if (unlocked) return <>{children}</>;

  return (
    <main
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black px-6"
      aria-label="Site access"
    >
      <form onSubmit={onSubmit} className="w-full max-w-xs">
        <label htmlFor="site-gate-password" className="sr-only">
          Password
        </label>
        <div className="flex items-stretch border border-white/30 focus-within:border-white">
          <input
            id="site-gate-password"
            type="password"
            autoFocus
            autoComplete="off"
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
              if (error) setError(false);
            }}
            className="flex-1 bg-transparent px-3 py-2 text-sm text-white placeholder:text-white/40 focus:outline-none"
            placeholder="Password"
            aria-invalid={error}
            aria-describedby={error ? "site-gate-error" : undefined}
          />
          <button
            type="submit"
            className="border-l border-white/30 px-4 text-xs uppercase tracking-widest text-white hover:bg-white hover:text-black transition-colors"
          >
            Enter
          </button>
        </div>
        {error && (
          <p
            id="site-gate-error"
            className="mt-3 text-center text-xs uppercase tracking-widest text-white/60"
            role="alert"
          >
            Incorrect
          </p>
        )}
      </form>
    </main>
  );
};

export default SiteGate;
